export const settingsMessages = {
  "settings.reminders.title": "Reading reminders",
  "settings.reminders.description":
    "Choose when Celsus may add a private reminder to your in-app inbox.",
  "settings.reminders.loading": "Loading reminder preferences…",
  "settings.reminders.enable": "Enable reading reminders",
  "settings.reminders.rules": "Reminder rules",
  "settings.reminders.inApp": "In-app inbox",
  "settings.reminders.channelHelp":
    "In-app is currently the only supported channel. Email and push are not enabled.",
  "settings.reminders.schedule": "Remind me on a schedule",
  "settings.reminders.days": "Reminder days",
  "settings.reminders.time": "Reminder time",
  "settings.reminders.inactivity": "Remind me after I have not read",
  "settings.reminders.inactivityDays": "Days without reading",
  "settings.reminders.goalPacing": "Remind me when I am behind my goal pace",
  "settings.reminders.quietStart": "Quiet hours start",
  "settings.reminders.quietEnd": "Quiet hours end",
  "settings.reminders.timezone":
    "Times use {timezone} and follow daylight-saving changes.",
  "settings.reminders.save": "Save reminder preferences",
  "settings.reminders.saved": "Reading reminder preferences saved.",
  "settings.reminders.chooseDay": "Choose at least one reminder day.",
  "settings.reminders.unsubscribe":
    "Turn off “Enable reading reminders” at any time to stop all reminders.",
  "settings.reminders.monday": "Monday",
  "settings.reminders.tuesday": "Tuesday",
  "settings.reminders.wednesday": "Wednesday",
  "settings.reminders.thursday": "Thursday",
  "settings.reminders.friday": "Friday",
  "settings.reminders.saturday": "Saturday",
  "settings.reminders.sunday": "Sunday",
  "settings.dataQuality.title": "Data quality",
  "settings.dataQuality.description":
    "Review explainable checks across your library, reading sessions, and imports. Nothing is changed automatically.",
  "settings.dataQuality.scanFailed": "The data-quality scan could not be loaded",
  "settings.dataQuality.emptyTitle": "No data-quality issues found",
  "settings.dataQuality.emptyDescription":
    "Your current library and reading history passed all available checks.",
  "settings.dataQuality.summary":
    "{total, plural, one {# issue} other {# issues}} found · {critical} critical · {warning} warnings",
  "settings.dataQuality.results": "Data-quality diagnostic results",
  "settings.dataQuality.previous": "Previous issues",
  "settings.dataQuality.next": "Next issues",
  "settings.duplicates.title": "Duplicate books",
  "settings.duplicates.description":
    "Review explainable matches and preview every relationship before merging. Different editions are never merged automatically.",
  "settings.duplicates.failed": "Duplicate review could not be loaded",
  "settings.duplicates.empty": "No possible duplicates found",
  "settings.duplicates.review": "Review merge",
  "settings.duplicates.preview": "Merge preview",
  "settings.duplicates.preserved":
    "{count} linked records will be preserved or combined.",
  "settings.duplicates.keepTarget": "Keep first entry",
  "settings.duplicates.keepSource": "Keep second entry",
  "settings.duplicates.merge": "Merge entries",
  "settings.language.title": "Language and region",
  "settings.language.description":
    "Choose the language used for Celsus. Regional preferences remain independent.",
  "settings.language.uiLocale": "Interface language",
  "settings.language.uiLocaleHelp":
    "Your choice is saved on this device and synchronized with your account.",
  "settings.language.timezone": "Detected timezone",
  "settings.language.currency": "Preferred currency",
  "settings.language.contentLanguages": "Content languages",
  "settings.language.taxCountry": "Tax country",
  "settings.language.notConfigured": "Not configured",
} as const;
